export default Object.freeze({
  // MEMBER_GROUP_
  TITLE: '회원그룹 관리',
  SETTING: '회원그룹 설정',
  BTN_ADD: '+회원그룹추가',
  GROUPS_EMPTY: '회원그룹을 생성 해 주세요.',
  TITLE_NAME: '그룹명',
  TITLE_NUM: '회원수',
  DETAIL_NEW_GROUP_NAME: '새 그룹명',
  DETAIL_NEW_GROUP_NO: '회원그룹 저장 시 번호가 할당됩니다.',

  BTN_SETTING: '변경사항 저장',

  DETAIL_EMPTY: '좌측에서 회원그룹을 추가 하시면, 상세설정이 가능합니다.',
  DETAIL_SETTING_TITLE: '그룹 상세설정',
  DETAIL_NAME: '그룹 이름',
  DETAIL_NO: '그룹 번호',
  DETAIL_DESCRIPTION: '그룹 설명',
  DETAIL_POINT_SETTING: '그룹 적립금 혜택',
  DETAIL_POINT: '적립',
  DETAIL_UNUSED: '사용 안 함',

  ERR_RESERVE_RATE: '입력형식이 잘못되었습니다.',
  ERR_RESERVE_RATE_100: '100 이하로 입력해주세요.',
  ERR_GROUP_NAME_NULL: '그룹 이름이 지정되지 않았습니다.',
  ERR_RESERVE_RATE_NULL: '그룹 적립금 혜택이 지정되지 않았습니다',
  ERR_RESERVE_RATE_ZERO: '그룹 적립금 혜택을 0%보다 크게 입력해주세요.',
  ERR_HAVE_MEMBER: '회원이 등록된 회원그룹은 삭제할 수 없습니다.',

  COMFIRM_BEFORE_MODIFY: '변경 된 내용을 저장하시겠습니까?',
  COMFIRM_MOVE: '변경한 내용을 저장하고 이동하시겠습니까?',
  COMFIRM_DELETE_GROUP: '등록된 회원그룹을 삭제하시겠습니까?',
  ALERT_SAVE: '변경사항이 저장 되었습니다.',
});
